import React, { memo } from 'react';

import FullCard from '../../../Components/fullCard';
import CardHeader from '../../../Components/cardHeader';
import { useTranslation } from 'react-i18next';
import PercentageBarWithDescription from '../../../Components/percentageBarWithDescription';

const WorkLoadTagGard = ({ name, data }) => {
  const { t } = useTranslation();
  return (
    <FullCard>
      <CardHeader
        name={`${name}`}
        customWidth="300px"
        toolTipText={t("workLoadTagCardTooltip")}
      />
      <PercentageBarWithDescription data={data} />
    </FullCard>
  );
};

export default memo(WorkLoadTagGard);
